import React, { ReactNode } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import theme from 'theme';
import PaymentPartners from 'parent-portal/payments/TandemPayInfo/PaymentPartners';

interface FooterProps {
    children?: ReactNode | ReactNode[];
}

export default function PageFooter({ children }: FooterProps) {
    const small = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Grid
            container
            justifyContent="space-between"
            direction={'row'}
            wrap="wrap"
            style={{ height: small ? undefined : 70, paddingBottom: 10 }}
        >
            <div style={{ paddingRight: 16, flexGrow: small ? 1 : 0 }}>{children}</div>
            <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', marginTop: small ? 16 : 0 }}>
                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 45 }}>
                    <PaymentPartners />
                </div>
            </div>
        </Grid>
    );
}
